import { render } from "./EmptyPart.vue?vue&type=template&id=05477d94&scoped=true"
import script from "./EmptyPart.vue?vue&type=script&lang=js"
export * from "./EmptyPart.vue?vue&type=script&lang=js"

import "./EmptyPart.vue?vue&type=style&index=0&id=05477d94&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05477d94"]])

export default __exports__